<div class="container">
  <div class="stay-connected-details-container">

    <img class="contact-icon" src="assets/contact-icon.svg" alt="Contact">
    <img class="messaging-icon" src="assets/messaging-icon.svg" alt="Messaging">
    <img class="red-rectangle" src="assets/merchant-landing-page/rectangle-red-icon.png">
    <img class="yellow-rectangle" src="assets/merchant-landing-page/rectangle-yellow-icon.png">

    <div class="stay-connected-title">
      <h1 i18n>Stay Connected</h1>
    </div>
    <p class="stay-connected-message" i18n>Join our culinary community to receive the latest updates, exclusive offers, and mouth-watering culinary tips directly to your inbox.</p>
    <div class="subscribe-email-div">
      <app-subscribe-email></app-subscribe-email>
    </div>
    <p class="follow-us-message" i18n>Follow us for more behind-the-scenes and delicious inspiration.</p>
    <div class="social-media-container">
      <a class="text-black" href="https://www.threads.net/@aklbaytimarketplace"><i class="bi-threads"></i></a>
      <a class="text-black" href="https://www.instagram.com/aklbaytimarketplace"><i class="bi-instagram"></i></a>
      <a class="text-black" href="https://www.facebook.com/aklbaytimarketplace"><i class="bi-facebook"></i></a>
    </div>
  </div>
</div>
